import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';
import { ONBOARDING_STAGES } from '../../lib/support';

/**
 * Where an onboarding is up to: five steps, done ones ticked, the current one
 * marked. The customer reads what each step means for them; we read the
 * stage's name. Steps differ by fill and by tick or number, not colour alone.
 */
export function OnboardingTrack({ stage, side = 'customer', className }) {
  const current = Math.max(0, ONBOARDING_STAGES.findIndex((s) => s.value === stage));
  const finished = stage === 'done';
  return (
    <ol className={cn('grid grid-cols-1 sm:grid-cols-5 gap-2', className)} data-testid="onboarding-track">
      {ONBOARDING_STAGES.map((s, i) => {
        const done = i < current || finished;
        const now = i === current && !finished;
        return (
          <li
            key={s.value}
            aria-current={now ? 'step' : undefined}
            className={cn(
              'rounded-cards px-3 py-2.5 flex items-center gap-2 min-w-0 text-sm',
              done && 'bg-moss-soft text-moss',
              now && 'bg-ochre-soft text-ochre font-medium',
              !done && !now && 'bg-mist text-muted-foreground'
            )}
          >
            <span
              className={cn(
                'w-5 h-5 shrink-0 rounded-full flex items-center justify-center text-[11px] tabular-nums',
                done ? 'bg-moss text-on-danger' : now ? 'border border-ochre' : 'border border-line-strong'
              )}
              aria-hidden="true"
            >
              {done ? <Check className="w-3 h-3" /> : i + 1}
            </span>
            <span className="min-w-0 leading-tight">{side === 'customer' ? s.customer : s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
